import { render, staticRenderFns } from "./BackgroundView.vue?vue&type=template&id=95598aa8"
import script from "./BackgroundView.vue?vue&type=script&lang=js"
export * from "./BackgroundView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports